

















































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Account } from '@/modules/backend/Entities/Account';
import { Location } from '@/modules/backend/Entities/Location';
import AccountCreateDialog from '@/components/accounts/AccountCreateDialog.vue';
import AccountDeleteButton from '@/components/accounts/AccountDeleteButton.vue';
import AccountEditDialog from '@/components/accounts/AccountEditDialog.vue';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import { DataTableHeader } from 'vuetify';
import Mixin from '@/mixins/base';
import { AccountsModule } from '@/store/dashboard/accounts/AccountsModule';
import { LocationsModule } from '@/store/dashboard/locations/LocationsModule';
import { resolveModule } from '@/store';
import { emptyPlaceholder } from '@/filters/emptyPlaceholder';

@Component({
  mixins: [Mixin],
  filters: { emptyPlaceholder },
  components: {
    DataTableWrapper,
    'account-create-dialog': AccountCreateDialog,
    'account-delete-button': AccountDeleteButton,
    'account-edit-dialog': AccountEditDialog
  }
})
export default class AccountsTable extends Mixins(Mixin) {
  private readonly locationsModule: LocationsModule = resolveModule(LocationsModule);
  private readonly accountsModule: AccountsModule = resolveModule(AccountsModule);

  private loading = false;

  @Prop({ required: true, type: Number })
  private readonly locationId!: number;

  private get accounts(): Account[] {
    if (this.currentLocation) {
      return this.accountsModule.AccountsByLocationId(this.locationId);
    }
    return [];
  }

  private get currentLocation(): Location | undefined {
    return this.locationsModule.LocationById(Number(this.locationId));
  }

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.isDesktop ? this.$t('common.table.headers.id').toString() : this.$t('common.table.headers.id_short').toString(),
        sortable: false,
        value: 'id'
      },
      {
        text: this.$i18n.t('screens.accounts.dialog_fields.title').toString(),
        value: 'name'
      },
      {
        text: this.$i18n.t('screens.accounts.dialog_fields.info').toString(),
        value: 'content'
      },
      {
        text: this.$i18n.t('common.table.headers.actions').toString(),
        sortable: false,
        align: 'end',
        value: 'actions'
      }
    ];
  }

  private async loadData(): Promise<void> {
    this.loading = true;
    await Promise.all([
      this.locationsModule.FetchSingle(this.locationId),
      this.accountsModule.Fetch(this.locationId)
    ]);
    this.loading = false;
  }

  @Watch('locationId', { immediate: true })
  private async locationChangedHandler(): Promise<void> {
    await this.loadData();
  }
}
